<span class="svg-container me-2" #helpMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="helpMenu">
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="26" height="26" rx="13" fill="white" stroke="#E8EAEE" stroke-width="2"/>
        <g clip-path="url(#clip0_7006_7116)">
        <path d="M16.8233 17.1765C14.3135 19.6863 13.7801 19.7803 10.9998 17C8.21942 14.2197 8.31042 13.6893 10.9998 11C13.6891 8.31066 14.1206 8.12087 16.9998 11C19.8789 13.8791 19.7801 14.2197 16.8233 17.1765Z" fill="#1363DF"/>
        <path d="M13.9998 16.3408L13.9998 14.2195" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.9998 12.0982C14.1462 12.0982 14.2649 11.9795 14.2649 11.833C14.2649 11.6866 14.1462 11.5679 13.9998 11.5679C13.8533 11.5679 13.7346 11.6866 13.7346 11.833C13.7346 11.9795 13.8533 12.0982 13.9998 12.0982Z" fill="white" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_7006_7116">
        <rect width="12" height="12" fill="white" transform="translate(9 8)"/>
        </clipPath>
        </defs>
        </svg>
    <span class="tooltiptext">Help Info</span>
</span>

<!-- Help Menu -->
<mat-menu #helpMenu="matMenu">
    <button mat-menu-item (click)="onOptionClick('doc_path')"><span style="font-family: 'Poppins'">Docs</span></button>
    <button mat-menu-item (click)="onOptionClick('video_path')"><span style="font-family: 'Poppins'">Video</span></button>
</mat-menu>
